import React, {useState,useEffect} from 'react';
import {Formulario, Input, Etiqueta, ContenedorBoton} from '../elementos/ElementosDeFormulario'
import Boton from '../elementos/Boton'
import Api from '../servicios/api';
import Alerta from '../elementos/Alerta'
import { useNavigate } from "react-router-dom";


const FormularioAutor = ({autor}) => {
    const [inputNombre, setInputNombre] = useState('');
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const navigate = useNavigate();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        if(autor){
            setInputNombre(autor.Aut_Nombre);
        }
    }, [autor]);

    const handleChange = (e) => {
        switch(e.target.name){
            case 'nombre':
                setInputNombre(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setEstadoAlerta(false);
        setAlerta({});

        // Validaciones del lado del cliente para que los inputs no esten vacios
        if(inputNombre === ''){
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'error',
                mensaje: 'Por favor rellena todos los datos'
            });
            return;
        }

        var datosEnviar;
        if(!autor){
            datosEnviar = {nombre:inputNombre}
            
            fetch(Api+"?insertarAutor",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                setInputNombre('');
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'exito',
                    mensaje: 'Autor registrado correctamente.'
                });
            })
            .catch(console.log)
        }

        else{
            datosEnviar = {id:autor.Aut_ID, nombre:inputNombre}

            fetch(Api+"?actualizarAutor",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                navigate("/autores");
            })
            .catch(console.log)
        }
    }

    return (
        <>
            <Formulario onSubmit={handleSubmit}>
                <div>
                    <Etiqueta htmlFor="">Nombre del Autor</Etiqueta>
                    <Input
                        type="text"
                        name="nombre"
                        placeholder="Ingrese Nombre"
                        value={inputNombre}
                        onChange={handleChange}
                    />
                </div>

                <ContenedorBoton>
                        <Boton to="/culturas">Cancelar</Boton>
                        <Boton as="button" type="submit" primario="true">
                            {autor ? 'Actualizar' : 'Guardar'} 
                        </Boton>
                </ContenedorBoton>
            </Formulario>

            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setEstadoAlerta={setEstadoAlerta}
            />
        </>
    );
}
 
export default FormularioAutor;